export default __webpack_public_path__ + "static/media/christmas-golingo.deded5ef.jpg";